<template>
    <svg width="7" height="32" viewBox="0 0 7 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 0L3.5 32" stroke="#00BF8C" stroke-width="3" stroke-dasharray="4 4" />
    </svg>
</template>
